import { FullStory, init, isInitialized } from '@fullstory/browser';
import { FSApi } from '@fullstory/snippet';

type UserIdentity = {
  name: string,
  email: string,
};

type UserProperties = {
  loan_number: string;
  merchant_id: string;
  merchant_uuid: string;
};

export class FullStoryWrapper {
  private readonly fs: FSApi;

  constructor() {
    init({
      orgId: 'o-1D2F2R-na1',
      namespace: 'FS',
      devMode: process.env.NODE_ENV === 'development',
      startCaptureManually: true,
    });

    this.fs = FullStory;
  }

  startCapture() {
    if (isInitialized()) {
      this.fs('start');
    }
  }

  identify(uid: string, properties: UserIdentity) {
    if (isInitialized()) {
      this.fs('setIdentity', {
        uid,
        properties: {
          displayName: properties.name,
          email: properties.email,
        }
      });
    }
  }

  addUserData(properties: UserProperties) {
    if (isInitialized()) {
      this.fs('setProperties', {
        type: 'user',
        properties
      });
    }
  }
}
